import React from "react";
import {createUseStyles} from "react-jss";
import {Colors} from "../../constants/colors";
import {ObservabilityPeriod, ObservabilityPeriodOption} from "../../types/observability";

interface Props {
  period: ObservabilityPeriod
  onPeriodChange: (period: ObservabilityPeriod) => void
}

const periodOptions: ObservabilityPeriodOption[] = [
  {value: 'day', label: '24H'},
  {value: 'week', label: '7 Days'},
  {value: 'month', label: '30 Days'}
]

const periodTitles: Record<ObservabilityPeriod, string> = {
  day: 'Show last 24 hours',
  week: 'Show last 7 days',
  month: 'Show last 30 days'
}

const ObservabilityPeriodSelector = ({period, onPeriodChange}: Props) => {
  const styles = useStyles()

  return (
    <div className={styles.container} aria-label="Observability period">
      {periodOptions.map(option => (
        <button
          key={option.value}
          type="button"
          className={[
            styles.button,
            period === option.value ? styles.buttonSelected : ''
          ].filter(Boolean).join(' ')}
          disabled={period === option.value}
          onClick={() => onPeriodChange(option.value)}
          aria-pressed={period === option.value}
          title={periodTitles[option.value]}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}

export default ObservabilityPeriodSelector

const useStyles = createUseStyles({
  container: {
    position: 'fixed',
    right: 24,
    bottom: 24,
    zIndex: 1000,
    display: 'flex',
    overflow: 'hidden',
    opacity: 0.72,
    transition: 'opacity 0.18s ease-in-out',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'rgba(255, 255, 255, 0.18)',
    borderRadius: 999,
    backgroundColor: 'rgba(0, 0, 0, 0.62)',
    boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.35)',
    '&:hover': {
      opacity: 1
    },
    '&:focus-within': {
      opacity: 1
    }
  },
  button: {
    height: 32,
    minWidth: 58,
    paddingLeft: 12,
    paddingRight: 12,
    borderWidth: 0,
    borderRightWidth: 1,
    borderRightStyle: 'solid',
    borderRightColor: 'rgba(255, 255, 255, 0.18)',
    backgroundColor: 'transparent',
    color: Colors.white,
    fontFamily: 'Aestetico-Bold',
    fontSize: 12,
    textTransform: 'uppercase',
    letterSpacing: 0,
    cursor: 'pointer',
    '&:last-child': {
      borderRightWidth: 0
    },
    '&:disabled': {
      cursor: 'default'
    },
    '&:not(:disabled):hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)'
    }
  },
  buttonSelected: {
    backgroundColor: Colors.euro_600
  }
})
